/* eslint-disable*/
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik'; // Import useFormik
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import {
  Grid,
  Link,
  Typography,
  Box,
  TextField,
  InputLabel,
  Button,
  Container,
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import useCommunityList from '../../../../hooks/useCommunityList';
import ModalEditViewDelete from '../../ModalEditViewDelete/ModalEditViewDelete';
const CommunityEditViewClimate = (props) => {
  const key = 'iFrasCwdJh';
  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  const [userId] = useState(loggedInUserData?.id);
  const [showDeleteBox, setShowDeleteBox] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [communityDetails, setCommunityDetails] = React.useState(null);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [climateValue, setClimateValue] = React.useState('');
  const [climateDesc, setClimateDesc] = React.useState('');
  const [isAccessible, setIsAccessible] = React.useState('');
  const maxCharacterCount = 700;
  const { addCommunityCatClimate, getCommunityDetailById } = useCommunityList();
  const params = useParams();
  const navigate = useNavigate();

  const onTakeMeback = (event) => {
    setShowDeleteBox(false);
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    const finalValue = e.target.value?.replace(/\s/g, '');
    console.log(finalValue, 8888);
    setClimateValue(value?.replace(/\s/g, ''));
  };

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    const finalValue = e.target.value?.replace(/\s/g, '');
    alert(finalValue, 9999);

    setClimateDesc(finalValue);
  };

  const formik = useFormik({
    initialValues: {
      communityId: params?.id,
      repId: loggedInUserData?.id,
      climateType: climateValue, // Use the captured value
      climateDesc: climateDesc,
      isAdminEntry: loggedInUserData?.roleId === 2,
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const trimmedClimateDesc = values?.climateDesc?.trim();
        values['climateDesc'] = trimmedClimateDesc;
        const response = await addCommunityCatClimate(values, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        console.log(response); // The response from the API
        formik.resetForm(); // Reset the form after successful submission
        navigate(`../../community-details/${params?.id}#Section8`);
        // Do something with the response, e.g., show a success message
      } catch (error) {
        console.error(error.response.data); // Log any error response from the API
        // Handle error, e.g., show an error message
      }
    },
  });

  const fillCommunityDetails = async () => {
    let communityDetailsResults = [];
    if (params?.id) {
      communityDetailsResults = await getCommunityDetailById({
        communityId: params?.id,
        userId,
      });
      setCommunityDetails(communityDetailsResults.data);
      setClimateDesc(communityDetailsResults?.data?.climate?.[0]?.climateDesc || '');
      setClimateValue(communityDetailsResults?.data?.climate?.[0]?.climateType || '');
    }
    return communityDetailsResults?.data;
  };

  useEffect(() => {
    fillCommunityDetails();
  }, []);

  const handleBackToParent = (e) => {
    e.preventDefault();
    if (formik.dirty) {
      setShowDeleteBox(true);
    } else {
      navigate(`../../community-details/${params?.id}#Section8`);
    }
  };

  useEffect(() => {
    loggedInUserData?.roleId === 1 || loggedInUserData?.roleId === 2
      ? setIsAccessible(true)
      : setIsAccessible(false);
  }, [loggedInUserData]);
  return (
    <Container>
      <Box className="PageSpacing FixedMD">
        {isAccessible ? (
          <>
            {showDeleteBox && (
              <>
                <ModalEditViewDelete
                  status={true}
                  navigateUrl={`../../community-details/${params?.id}#Section8`}
                  onClose={onTakeMeback}
                ></ModalEditViewDelete>
              </>
            )}
            <Grid container>
              <Grid item xs={12}>
                <Link
                  underline="none"
                  onClick={(e) => {
                    handleBackToParent(e);
                  }}
                  className="BackButtonWrapper"
                >
                  <Typography className="BackButton" variant="body1">
                    <ArrowBackIcon color="primary" className="BackButtonArrow" />
                    Climate Insights
                  </Typography>
                </Link>
              </Grid>
            </Grid>
            <Grid container className="FixedID">
              <Grid item xs={12} className="CommonOption">
                <Box className="HeadingBoxCEV FlexCenterStart">
                  <Typography variant="body2" className="HeadingCEV">
                    Climate Type
                  </Typography>
                  <Typography variant="body2" className="HeadingCEVCaption">
                    Select one
                  </Typography>
                </Box>
                <Typography variant="body2" className="SubtitleCEV">
                  Inputting this content helps users find your community when filtering.
                </Typography>
              </Grid>
              <Grid item xs={12} className="CommonOption">
                <Box className="RadioOption">
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="Climate Type"
                      name="climateValue"
                      value={climateValue}
                      onChange={handleChange1}
                      {...formik.getFieldProps('climateType')}
                    >
                      <FormControlLabel
                        value="tropicalSubtropical"
                        control={<Radio color="primary" />}
                        label="Tropical / Subtropical"
                      />
                      <FormControlLabel
                        value="dryArid"
                        control={<Radio color="primary" />}
                        label="Dry / Arid"
                      />
                      <FormControlLabel
                        value="temperateCoolWintersMildSummers"
                        control={<Radio color="primary" />}
                        label="Temperate / Cool Winters & Mild Summers"
                      />
                      <FormControlLabel
                        value="ContinentalColdWintersHotSummers"
                        control={<Radio color="primary" />}
                        label="Continental / Cold Winters & Hot Summers"
                      />
                      <FormControlLabel
                        value="Polar"
                        control={<Radio color="primary" />}
                        label="Polar"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" mt={2}>
                  <InputLabel className="InputLabelFld">
                    What can people look forward to across the four seasons?
                  </InputLabel>
                </Box>
                <TextField
                  className="TextFieldTextarea"
                  fullWidth
                  multiline
                  minRows={8}
                  maxLength={700}
                  label=""
                  variant="outlined"
                  value={climateDesc}
                  onChange={handleChange2}
                  {...formik.getFieldProps('climateDesc')}
                  inputProps={{
                    maxLength: maxCharacterCount,
                  }}
                  // helperText={`${maxCharacterCount - climateDesc.length}`}
                  helperText={`${maxCharacterCount - formik.values.climateDesc.length}`}
                />
              </Grid>

              <Grid item xs={12}>
                <div className="Wrapper ButtonWrapper">
                  <Button
                    // disabled={
                    //   !publishBool && climateDesc.length == 0 && climateValue == ''
                    //     ? false
                    //     : climateDesc.length == 0 && climateValue == ''
                    // }
                    disabled={
                      !formik.dirty ||
                      (!climateDesc.length === 0 && !climateValue === 0 && !isEdited)
                    }
                    onClick={formik.handleSubmit}
                    variant="contained"
                    color="primary"
                    className="EditViewButton"
                    fullWidth
                  >
                    Publish
                  </Button>
                </div>
              </Grid>
            </Grid>
          </>
        ) : (
          'You do not have permissions to access this url.'
        )}
      </Box>
    </Container>
  );
};
CommunityEditViewClimate.defaultProps = {};
export default CommunityEditViewClimate;
